export default __webpack_public_path__ + "static/media/rectangleGroupRight.de1a7fc0.svg";